

const version = {
    id: 'version',
    title: 'version',
    type: 'version',
    children: [
        {
            id: 'version',
            title: 'version',
            type: 'version-item',
            breadcrumbs: false
        }
    ]
};

export default version;
